<template>
  <!-- 对接详情 -->
  <div class="DockingDetails">

  
    <Head />
   
    <!-- 对接详情的头部nav -->
    <DockingSystemHead :msg="DetailsData" />
    
    <!-- 对接详情上部 -->
    <DockingDetailsTop :msg="DetailsData" />
   
    <!-- 对接详情中部 -->
    <DockingDetailsCenter :msg="DetailsData" />

    <!-- 对接详情底部 -->
    <Foot />

  </div>
</template>

<script>
  import Head from "@/components/Head/Head.vue";
  import Foot from "@/components/Foot/Foot.vue";
  import DockingSystemHead from "@/components/DockingSystem/Head/DockingSystemHead.vue"; //对接详情的头部nav
  import DockingDetailsTop from "@/components/DockingSystem/DockingDetails/DockingDetailsTop.vue"; //对接详情上部
  import DockingDetailsCenter from "@/components/DockingSystem/DockingDetails/DockingDetailsCenter.vue"; //对接详情中部
  // import BusinessDetailsBottom from "@/components/DockingSystem/DockingDetails/BusinessDetailsBottom.vue"; //对接详情底部

  import axios from "axios"
  export default {
    props: {},
    components: {
      Head,
      Foot,
      DockingSystemHead,
      DockingDetailsTop,
      DockingDetailsCenter,
      // BusinessDetailsBottom,
    },
    data() {
      return {
        DetailsData: {},//对接会详情内容
      };
    },
    created: function () {
      let id = this.$route.query.id;
      console.log('this.$route', this.$route.query.id);
      this.getDetails(id);//获取云对接详情
    },
    methods: {
      getDetails(id) {
        let self = this;
        //获取云对接详情
        axios.get('/api/jointactivitydetails', {
          params: {
            id: id
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {
              self.DetailsData = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
    },
  };
</script>

<style scoped>
  .DockingDetails {}
</style>